
<template>
	<div>

		<div class="textlinks-items">
			<div v-for="textlink in textlinks" class="textlink-item" :data-textlink-id="textlink.id" @mousedown.prevent="mousedownTextlinks(textlink,$event)">
				<a :href="textlink.url" target="_blank">{{ textlink.name }}</a>
				<span class="textlink-button textlink-button-editar" @click="formTextlinkEdit(textlink)"><i><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z" /></svg></i></span>
			</div>
		</div>

	</div>
</template>

<style>


.textlinks-items{ border-radius: 10px; overflow:hidden; box-shadow: 0px 0px 3px 1px rgba(0,0,0,0.15); }
.textlink-item{ background: #fff;  position: relative;  font-size:.8em; right: 0; display: flex;  border-top:1px solid #ccc; border-bottom:1px solid #ccc; margin-top:-1px; user-select: none;}
.textlink-item a { padding:5px 5px 5px 10px; flex-grow:1; color:#00bfff; user-select: none; }
.textlink-button { display:none; margin:3px; line-height: 1; cursor: pointer; }
.textlink-button i { display:inline-block; width:10px; height:10px; }
.textlink-button svg { display: block; width:100%; height:100%; }
.textlink-button svg path{ fill:#333;}
.textlink-button-editar {  }
.textlink-item:hover .textlink-button { display: block; }
.textlink-item:hover { background-color:#eee; }
.textlink-item.placeholder { background:none; outline: 2px dashed #1cc4cf; outline-offset: -2px;  transition: transform 0.2s; }
.textlink-item.dragging {
  pointer-events: none;
  position: fixed;
  box-shadow: 5px 5px 5px rgba(0,0,0,.2);
  z-index: 2;
  transform: rotate(-2deg);
}

</style>

<script>

	import firebase from '@/firebase'

	export default {
		computed:{
			user(){
				return this.$store.getters.user;
			},
			userId(){
				return this.$store.getters.userId;
			},
			config(){
				return this.$store.state.config;
			},
			preferences(){
				return this.$store.getters.preferences;
			},
			textlinks(){
				return this.$store.getters.orderedTextlinks;
			},
		},
		data() {
			return {
				dndTextlinks:{
					mouseDown:false,
					dragging:false,
					textlink:null,
					element:null,
					offset:{x:0, y:0, },
					mouse:{x:0, y:0, },
					indexHover:null,
				},

				db:null,
			}
		},
		methods:{


			formTextlinkEdit(textlink){
				this.$router.push({name:'formTextlink',params:{item:textlink}})
			},


			getIndexHover(y){
				var indexHover = null;
				var textlinks = this.textlinks;
				var index;
				for (index in textlinks){
					if(textlinks[index].id == this.dndTextlinks.element.getAttribute('data-textlink-id')) continue;
					var rect = document.querySelector('.textlink-item[data-textlink-id="'+textlinks[index].id+'"]').getBoundingClientRect();
					if(y <= rect.y) return textlinks[index].index;
					if(y >= rect.y && y <= rect.y+rect.height/2) return textlinks[index].index;
					if(y >= rect.y+rect.height/2 && y <= rect.y+rect.height) return textlinks[index].index+1;
				}
				return null
			},

			mousedownTextlinks(textlink,e){
				e.stopPropagation();
				console.log(textlink);
				this.dndTextlinks.textlink = textlink;
				this.dndTextlinks.element = document.querySelector('.textlink-item[data-textlink-id="'+textlink.id+'"]');
				console.log('textlink',textlink);
				console.log('elemen',this.dndTextlinks.element);
				this.dndTextlinks.offset.x = e.offsetX;
				this.dndTextlinks.offset.y = e.offsetY;

     		//record coordinates to start draggin 10px after this
     		this.dndTextlinks.mouse.x = e.clientX;
     		this.dndTextlinks.mouse.y = e.clientY;

     		this.dndTextlinks.mouseDown = true;

     	},

     	mousemoveTextlinks(e){
     		if(!this.dndTextlinks.dragging){
     			if(Math.abs(this.dndTextlinks.mouse.x-e.clientX)<10 && Math.abs(this.dndTextlinks.mouse.y-e.clientY)<10) return;
     			this.dndTextlinks.dragging = true;
     			this.dndTextlinks.element.style.width = this.dndTextlinks.element.offsetWidth+'px';
     			this.dndTextlinks.element.classList.add('dragging');
     		}

     		this.dndTextlinks.element.style.left = (e.clientX - this.dndTextlinks.offset.x) + 'px';
     		this.dndTextlinks.element.style.top = (e.clientY - this.dndTextlinks.offset.y) + 'px';

     		var movePlaceholder = false;

     		var indexHover = this.getIndexHover(e.clientY);
     		if(indexHover && this.dndTextlinks.indexHover!=indexHover){
     			console.log('change index ',indexHover);
     			this.dndTextlinks.indexHover = indexHover;
     			movePlaceholder = true;
     		}

     		if(movePlaceholder) {
	        //remove existing placeholder
	        document.querySelectorAll('.placeholder').forEach((placeholder) => { placeholder.parentNode.removeChild(placeholder); });

	        //create new placeholder
	        var placeholder = document.createElement('div');
	        placeholder.className = 'textlink-item placeholder';
	        placeholder.style.height = this.dndTextlinks.element.offsetHeight+'px';

	        //insert on chosen position
	        var textlinks = this.textlinks.filter(textlink => textlink.index==this.dndTextlinks.indexHover);
	        if(textlinks.length){
	        	var textlinkElement = document.querySelector('.textlink-item[data-textlink-id="'+textlinks[0].id+'"]');
	        	textlinkElement.parentNode.insertBefore(placeholder,textlinkElement);
	        } else {
	        	document.querySelector('.textlinks-items').appendChild(placeholder);
	        }
	      }
	    },

	    mouseupTextlinks(e){
	    	this.dndTextlinks.dragging = false;
	    	this.dndTextlinks.textlink.index= this.dndTextlinks.indexHover-0.5;

	      //atualizar index dos demais elementos
	      this.$store.dispatch('changeTextlinkOrder',{textlink_id:this.dndTextlinks.textlink.id,index:this.dndTextlinks.textlink.index});

	      this.dndTextlinks.element.style.width='';
	      this.dndTextlinks.element.style.top='';
	      this.dndTextlinks.element.style.left='';
	      this.dndTextlinks.element.classList.remove('dragging');

	      //remove placeholder
	      document.querySelectorAll('.placeholder').forEach((placeholder) => { placeholder.parentNode.removeChild(placeholder); })
	    },

	  },
	  created(){
	  	this.db = firebase.firestore();

	  	document.querySelector('body').addEventListener('mousemove',(e)=>{
	  		if(this.dndTextlinks.mouseDown) return this.mousemoveTextlinks(e);

	  	});

	  	document.querySelector('body').addEventListener('mouseup',(e)=>{
	  		this.dndTextlinks.mouseDown = false;
	  		if(this.dndTextlinks.dragging) return this.mouseupTextlinks(e);
	  	});
	  }

	}

</script>

